:root ._dsp-flex{display:flex;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-row{flex-direction:row;}
:root ._mt-t-space-sma3456{margin-top:var(--t-space-small);}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._items-center{align-items:center;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._btlr-5px{border-top-left-radius:5px;}
:root ._btrr-5px{border-top-right-radius:5px;}
:root ._bbrr-5px{border-bottom-right-radius:5px;}
:root ._bblr-5px{border-bottom-left-radius:5px;}
:root ._width-10px{width:10px;}
:root ._height-10px{height:10px;}
:root ._btc-ccc35{border-top-color:#ccc;}
:root ._brc-ccc35{border-right-color:#ccc;}
:root ._borderBottomColor-ccc35{border-bottom-color:#ccc;}
:root ._borderLeftColor-ccc35{border-left-color:#ccc;}
:root ._bg-color{background-color:var(--color);}
:root ._bg-backgroundB3327275{background-color:var(--backgroundBlock);}
:root ._btw-1px{border-top-width:1px;}
:root ._brw-1px{border-right-width:1px;}
:root ._borderBottomWidth-1px{border-bottom-width:1px;}
:root ._borderLeftWidth-1px{border-left-width:1px;}
:root ._borderBottomStyle-solid{border-bottom-style:solid;}
:root ._borderTopStyle-solid{border-top-style:solid;}
:root ._borderLeftStyle-solid{border-left-style:solid;}
:root ._borderRightStyle-solid{border-right-style:solid;}
:root ._btw-0px{border-top-width:0px;}
:root ._brw-0px{border-right-width:0px;}
:root ._borderBottomWidth-0px{border-bottom-width:0px;}
:root ._borderLeftWidth-0px{border-left-width:0px;}